"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OrgUsersService", {
    enumerable: true,
    get: function() {
        return OrgUsersService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _uuid = require("uuid");
const _validator = /*#__PURE__*/ _interop_require_default(require("validator"));
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _baseusersservice = require("~/services/base-users/base-users.service");
const _mailservice = require("~/services/mail/mail.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _extractProps = require("~/helpers/extractProps");
const _stringHelpers = require("~/helpers/stringHelpers");
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _Mail = require("~/interface/Mail");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let OrgUsersService = class OrgUsersService {
    async userList(param) {
        const users = await _models.User.list(param.query);
        await _models.PresignedUrl.signMetaIconImage(users);
        return users;
    }
    async userUpdate(param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/OrgUserReq', param.user);
        const updateBody = (0, _extractProps.extractProps)(param.user, [
            'roles'
        ]);
        const user = await _models.User.get(param.userId);
        if ((0, _nocodbsdk.extractRolesObj)(user.roles)[_nocodbsdk.OrgUserRoles.SUPER_ADMIN]) {
            _catchError.NcError.badRequest('Cannot update super admin roles');
        }
        await this.mailService.sendMail({
            mailEvent: _Mail.MailEvent.ORGANIZATION_ROLE_UPDATE,
            payload: {
                req: param.req,
                user,
                newRole: param.user.roles,
                oldRole: user.roles
            }
        });
        return await _models.User.update(param.userId, _extends({}, updateBody));
    }
    async userDelete(param) {
        const ncMeta = await _Noco.default.ncMeta.startTransaction();
        try {
            const user = await _models.User.get(param.userId, ncMeta);
            if ((0, _nocodbsdk.extractRolesObj)(user.roles)[_nocodbsdk.OrgUserRoles.SUPER_ADMIN]) {
                _catchError.NcError.badRequest('Cannot delete super admin');
            }
            // delete base user entry and assign to super admin
            const baseUsers = await _models.BaseUser.getProjectsIdList(param.userId, ncMeta);
            // todo: clear cache
            // TODO: assign super admin as base owner
            for (const baseUser of baseUsers){
                await _models.BaseUser.delete({
                    workspace_id: baseUser.fk_workspace_id,
                    base_id: baseUser.base_id
                }, baseUser.base_id, baseUser.fk_user_id, ncMeta);
            }
            // delete sync source entry
            await _models.SyncSource.deleteByUserId(param.userId, ncMeta);
            // delete user
            await _models.User.delete(param.userId, ncMeta);
            await ncMeta.commit();
        } catch (e) {
            await ncMeta.rollback(e);
            if (e instanceof _catchError.NcError || e instanceof _catchError.NcBaseError) throw e;
            this.logger.error('Error deleting user', e);
            _catchError.NcError.orgUserError('Bad Request');
        }
        return true;
    }
    async userAdd(param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/OrgUserReq', param.user);
        // allow only viewer or creator role
        if (param.user.roles && ![
            _nocodbsdk.OrgUserRoles.VIEWER,
            _nocodbsdk.OrgUserRoles.CREATOR
        ].includes(param.user.roles)) {
            _catchError.NcError.badRequest('Invalid role');
        }
        // extract emails from request body
        const emails = (param.user.email || '').toLowerCase().split(/\s*,\s*/).map((v)=>v.trim()).filter(Boolean);
        // check for invalid emails
        const invalidEmails = emails.filter((v)=>!_validator.default.isEmail(v));
        if (!emails.length) {
            return _catchError.NcError.badRequest('Invalid email address');
        }
        if (invalidEmails.length) {
            _catchError.NcError.badRequest('Invalid email address : ' + invalidEmails.join(', '));
        }
        const invite_token = (0, _uuid.v4)();
        const error = [];
        for (const email of emails){
            // add user to base if user already exist
            let user = await _models.User.getByCanonicalEmail(email);
            if (user) {
                _catchError.NcError.badRequest('User already exist');
            } else {
                try {
                    // create new user with invite token
                    user = await _models.User.insert({
                        invite_token,
                        invite_token_expires: new Date(Date.now() + 24 * 60 * 60 * 1000),
                        email,
                        roles: param.user.roles || _nocodbsdk.OrgUserRoles.VIEWER,
                        token_version: (0, _stringHelpers.randomTokenString)()
                    });
                    const count = await _models.User.count();
                    this.appHooksService.emit(_nocodbsdk.AppEvents.ORG_USER_INVITE, {
                        user,
                        count,
                        req: param.req
                    });
                    // in case of single user check for smtp failure
                    // and send back token if failed
                    if (emails.length === 1) {
                        try {
                            const res = await this.mailService.sendMail({
                                mailEvent: _Mail.MailEvent.ORGANIZATION_INVITE,
                                payload: {
                                    user,
                                    req: param.req,
                                    token: invite_token
                                }
                            });
                            if (!res) {
                                return {
                                    invite_token,
                                    email
                                };
                            }
                        } catch (e) {
                            return {
                                invite_token,
                                email
                            };
                        }
                    } else {
                        await this.mailService.sendMail({
                            mailEvent: _Mail.MailEvent.ORGANIZATION_INVITE,
                            payload: {
                                user,
                                req: param.req,
                                token: invite_token
                            }
                        });
                    }
                } catch (e) {
                    console.log(e);
                    if (emails.length === 1) {
                        _catchError.NcError.orgUserError('Bad Request');
                    } else {
                        error.push({
                            email,
                            error: e.message
                        });
                    }
                }
            }
        }
        if (emails.length === 1) {
            return {
                msg: 'success'
            };
        } else {
            return {
                invite_token,
                emails,
                error
            };
        }
    }
    async userSettings(_param) {
        _catchError.NcError.notImplemented();
    }
    async userInviteResend(param) {
        const user = await _models.User.get(param.userId);
        if (!user) {
            _catchError.NcError.userNotFound(param.userId);
        }
        const invite_token = (0, _uuid.v4)();
        await _models.User.update(user.id, {
            invite_token,
            invite_token_expires: new Date(Date.now() + 24 * 60 * 60 * 1000)
        });
        const pluginData = await _Noco.default.ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.PLUGIN, {
            category: _nocodbsdk.PluginCategory.EMAIL,
            active: true
        });
        if (!pluginData) {
            _catchError.NcError.badRequest(`No Email Plugin is found. Please go to App Store to configure first or copy the invitation URL to users instead.`);
        }
        await this.mailService.sendMail({
            mailEvent: _Mail.MailEvent.ORGANIZATION_INVITE,
            payload: {
                user,
                req: param.req,
                token: invite_token
            }
        });
        this.appHooksService.emit(_nocodbsdk.AppEvents.ORG_USER_RESEND_INVITE, {
            user: user,
            req: param.req
        });
        return true;
    }
    async generateResetUrl(param) {
        const user = await _models.User.get(param.userId);
        if (!user) {
            _catchError.NcError.userNotFound(param.userId);
        }
        const token = (0, _uuid.v4)();
        await _models.User.update(user.id, {
            email: user.email,
            reset_password_token: token,
            reset_password_expires: new Date(Date.now() + 60 * 60 * 1000),
            token_version: (0, _stringHelpers.randomTokenString)()
        });
        return {
            reset_password_token: token,
            reset_password_url: param.siteUrl + `/dashboard/#/reset/${token}`
        };
    }
    async appSettingsGet() {
        return await _Noco.default.getAppSettings();
    }
    async appSettingsSet(param) {
        await _Noco.default.updateAppSettings(param.settings);
        return true;
    }
    constructor(baseUsersService, appHooksService, mailService){
        this.baseUsersService = baseUsersService;
        this.appHooksService = appHooksService;
        this.mailService = mailService;
        this.logger = new _common.Logger(OrgUsersService.name);
    }
};
OrgUsersService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _baseusersservice.BaseUsersService === "undefined" ? Object : _baseusersservice.BaseUsersService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _mailservice.MailService === "undefined" ? Object : _mailservice.MailService
    ])
], OrgUsersService);
